// import Cookies from "js-cookie";
const TokenKey = 'liveAssistant-Token';
const userInfoKey = 'userInfo';
export function getToken() {
  return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
  return sessionStorage.setItem(TokenKey, `${token}`);
}

export function removeToken() {
  return sessionStorage.removeItem(TokenKey);
}

export function getUserInfo() {
  return sessionStorage.getItem(userInfoKey);
}

export function setUserInfo(info) {
  return sessionStorage.setItem(userInfoKey, info);
}

export function setSid(sid) {
  return sessionStorage.setItem('sid', sid);
}

export function getSid() {
  return sessionStorage.getItem('sid');
}
